import Select from "@/components/Select";
import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { useController, useFormContext, useWatch } from "react-hook-form";

interface SubCategorySelectProps {
  categoryIndex: number;
}

function SubCategorySelect({ categoryIndex }: SubCategorySelectProps) {
  const { control } = useFormContext<FormValues>();

  const subcategories = useWatch({
    control,
    name: `categories.${categoryIndex}.subcategories`,
  });
  const subCategoryOptions = subcategories.map((subCategory) => ({
    label: subCategory.content,
    value: subCategory.id,
  }));

  const { field: selectedSubCategoryField } = useController({
    control,
    name: `categories.${categoryIndex}.selectedSubCategory`,
  });

  return (
    <Select
      width="200px"
      options={subCategoryOptions}
      value={selectedSubCategoryField.value}
      className="rounded-md border"
      onChange={(value) => selectedSubCategoryField.onChange(value)}
    />
  );
}

export default SubCategorySelect;
